import { Button, ButtonProps, useTheme } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import useMuseStyles from '../../themes/useMuseStyles'

export default function CommunityTableActionButton(props: ButtonProps) {
    const gclasses = useMuseStyles(useTheme())

    const classes = {
        label: gclasses.primaryColor,
        disabled: gclasses.circleButtonDisabled,
        ...props.classes,
    }
    const style = { padding: 0, width: 28, height: 28, ...props.style }

    const propsOverride = { ...props }
    delete propsOverride['style']
    delete propsOverride['classes']

    return (
        <Button
            variant="outlined"
            color="primary"
            className={clsx(gclasses.circleButton)}
            classes={classes}
            style={style}
            {...propsOverride}
        >
            {props.children}
        </Button>
    )
}
